import React from 'react';
import './Advantages.css';

const advantages = [
  { title: 'AI驱动', desc: '智能数据分析、异常识别、风险预测' },
  { title: '全流程覆盖', desc: '从数据采集到报告生成，无缝衔接' },
  { title: '行业深耕', desc: '聚焦审计场景，适配多领域需求' },
  { title: '安全可靠', desc: '数据加密、合规认证、系统稳定' },
];

const Advantages: React.FC = () => (
  <section className="advantages">
    <h2>核心优势</h2>
    <div className="advantages-list">
      {advantages.map((item, idx) => (
        <div className="advantage-card" key={idx}>
          <h3>{item.title}</h3>
          <p>{item.desc}</p>
        </div>
      ))}
    </div>
  </section>
);

export default Advantages; 